const sticky = document.querySelector('.compare-infos');
const stickyTop = sticky.offsetTop;

window.addEventListener('scroll', () => {
  if (window.scrollY > stickyTop) {
    sticky.classList.add('sticked');
  } else {
    sticky.classList.remove('sticked');
  }
});

function initMobileSelectorsAndItems() {
  document.querySelector('.compare-select select-wrapper:last-child').remove();
  const ElementsToReset = document.querySelector('.compare-actions .compare-action:nth-child(3), .compare-images > .media-wrapper:nth-child(3)');
  ElementsToReset.classList.add('small-hide');
  ElementsToReset.classList.add('medium-hide');
  ElementsToReset.classList.add('large-up-hide');


  const SelectsToReset =document.querySelectorAll('.compare-select option:nth-child(3)')
  SelectsToReset.forEach(SelectToReset => {
    SelectToReset.disabled = false;
  });

  const columnsToRemove = document.querySelectorAll('.compare-grid:not(.compare-select) > *:nth-child(3)');
  columnsToRemove.forEach(columnToRemove => {
    columnToRemove.classList.add('small-hide');
    columnToRemove.classList.add('medium-hide');
    columnToRemove.classList.add('large-up-hide');
  });
}
function updateSelectorsAndItems(isMobile) {
  const selectors = document.querySelectorAll(".compare-select select");
  const selectedValues = Array.from(selectors).map(sel => sel.value);
  selectors.forEach(select => {
    Array.from(select.options).forEach(option => {
      option.disabled = false; // reset
      if (selectedValues.includes(option.value) && select.value !== option.value) {
        option.disabled = true;
      }
    });
  });

  const items = document.querySelectorAll('[data-uid]');
  items.forEach(item => {
    const uid = item.getAttribute('data-uid');
    if (selectedValues.includes(uid)) {
      const matchingSelect = Array.from(selectors).find(sel => sel.value === uid);
      if (matchingSelect) {
        const identifier = matchingSelect.getAttribute('data-identifier');
        item.classList.remove('small-hide');
        item.classList.remove('medium-hide');
        item.classList.remove('large-up-hide');
        item.style.order = identifier;
        if (identifier == 1) {
          item.classList.add('first-visible');
        }
      }
    } else {
      item.classList.add('small-hide');
      item.classList.add('medium-hide');
      item.classList.add('large-up-hide');
      item.classList.remove('first-visible');
      item.style.order = '';
    }
  });
}
const selectors = document.querySelectorAll(".compare-select select");
selectors.forEach(select => {
  select.addEventListener('change', updateSelectorsAndItems);
});

document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  if (isMobile) {
    initMobileSelectorsAndItems();
  }
  updateSelectorsAndItems(isMobile);
});

